import { Controller } from "stimulus";
import { EventCurrencyChanged } from "../events";
import { getActiveCurrency } from "../util/currency";

export default class extends Controller {
  static targets = [
    "postMessage", "coinId", "currency", "form", "transactionType", "noteInputField",
    "balance", "transferInputField", "priceInputField", "transferTypeSelection",
    "dateInputField", "feeInputField", "quantityInputField",
  ]

  connect() {
    window.addEventListener(EventCurrencyChanged, e => this._updateCurrency());
  }

  updateTransactionType(event) {
    if (["buy", "sell"].includes(event.currentTarget.dataset.type)) {
      this.transactionTypeTarget.value = event.currentTarget.dataset.type;
    } else {
      const selectInput = this.transferTypeSelectionTarget,
            transferTypeValue = selectInput.options[selectInput.selectedIndex].value;
      this.transactionTypeTarget.value = transferTypeValue;
    }
  }

  toggleTransactionForm(event) {
    if (["buy", "sell"].includes(event.currentTarget.dataset.type)) {
      this.toggleInputField(event.currentTarget.dataset.type);
    } else {
      this.toggleInputField("transfer");
    }

    this.updateTransactionType(event);
  }

  toggleInputField(type) {
    if (["buy", "sell"].includes(type)) {
      this.transferInputFieldTarget.classList.add("d-none");
      this.priceInputFieldTarget.classList.remove("d-none");
      this.priceInputFieldTarget.querySelector("input").required = true;
      this.transferInputFieldTarget.querySelector("select").required = false;
    } else {
      this.transferInputFieldTarget.classList.remove("d-none");
      this.transferInputFieldTarget.querySelector("select").required = true;
      this.priceInputFieldTarget.classList.add("d-none");
      this.priceInputFieldTarget.value = null;
      this.priceInputFieldTarget.querySelector("input").required = false;
    }
  }

  onPostError(e) {
    let [data, status, xhr] = e.detail;

    const errors = JSON.parse(xhr.response);
    this._renderFormErrors(errors);
  }

  _updateCurrency() {
    this.currencyTarget.value = getActiveCurrency();
  }

  _renderFormErrors(errors) {
    const formEl = this.formTarget;
    const model = formEl.getAttribute("data-model");

    for (const [field, messages] of Object.entries(errors)) {
      const input = formEl.querySelector('input[name="' + model + '[' + field + ']"]');
      input.classList.add("is-invalid");
      input.closest('.form-group').querySelector('.text-danger').innerHTML = messages.join(" & ");
    }

    this.postMessageTarget.innerHTML = "";
  }

  _clearFormErrors() {
    const formEl = this.formTarget;
    formEl.querySelectorAll("input").forEach(inputEl => {
      inputEl.classList.remove("is-invalid");
    })
    formEl.querySelectorAll(".text-danger").forEach(node => {
      node.innerHTML = "";
    })
  }
}
